import React from 'react';
import logo from 'assets/images/logo-2-color.svg';
import { useTranslation } from 'react-i18next';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import useAsyncFetch from 'hooks/async-fetch';
import PageLoader from 'components/Loaders/PageLoader';
import { authService } from 'services/api/auth';
import styles from './deactivation-confirm-page.module.scss';

const DeactivationConfirmPage = () => {
  const [t] = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token');

  const [error, setError] = React.useState<string | null>(null);

  const [handleConfirmDeactivation, loading, result] = useAsyncFetch({
    async asyncFunc() {
      await authService.deactivateAccountConfirm(token || '');
      return true;
    },
    errorHandler: ({ errMessage }) => {
      setError(errMessage);
    },
    initialState: false,
  });

  React.useEffect(() => {
    handleConfirmDeactivation();
  }, []);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className={styles.deactivationConfirmPage}>
      <div className={styles.logo}>
        <img src={logo} width={200} height={80} alt="pro-data" />
      </div>
      {loading && <PageLoader />}
      {!loading && result && (
        <>
          <h1 className="font-heading mb-5">{t('self-block.description.7')}</h1>
          <p>{t('self-block.description.8')}</p>
          <Link className="btn btn-outline-secondary" to="/" replace qa-element="back-to-main">{t('common.back_to_main')}</Link>
        </>
      )}
      {!loading && error && (
        <>
          <h1 className="font-heading mb-5">{error}</h1>
          <Link className="btn btn-outline-secondary" to="/" replace qa-element="back-to-main">{t('common.back_to_main')}</Link>
        </>
      )}
    </main>
  );
};

export default DeactivationConfirmPage;
